<template>
  <custom-dialog width="500px" :title="model.title" :visible="visible" v-on="$listeners">
    <div v-if="model.row.goalTime && model.row.goalArea" style="font-size: 13px; padding-left: 26px; color: #454545; line-height: 22px">
      <span>
        {{ cleanAreaDay }}:
        <strong style="color: #00a0d9">{{ $formatLenLocal(model.row.goalArea) }}</strong>
      </span>
      <span style="margin: 0 20px">|</span>
      <span>
        {{ $t('target_dialog_qjsct') }}:
        <strong style="color: #00a0d9">{{ model.row.goalTime }}</strong>
      </span>
    </div>
    <div class="dialog-body">
      <el-form :model="form" ref="form" :rules="rules" :validate-on-rule-change="false" label-position="top">
        <el-form-item :label="cleanAreaDay" prop="goalArea">
          <el-input v-model="form.goalArea" style="width: 440px"></el-input>
        </el-form-item>
        <el-form-item :label="$t('target_dialog_qjsct_1')" prop="goalTime">
          <el-input v-model="form.goalTime" style="width: 440px"></el-input>
        </el-form-item>
      </el-form>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button size="small" @click="visible = false">{{ $t('com_cancel') }}</el-button>
      <el-button size="small" type="warning" @click="confirm">{{ $t('com_confirm') }}</el-button>
    </div>
  </custom-dialog>
</template>

<script>
import apis from '@/utils/apis';
import dialogMixins from '@/mixins/dialog_mixins';

// target_dialog_qjsct: 清洁时长（min）/天// target_dialog_qjsct_1: 清洁时长（min）/天// target_dialog_qjmjt: 清洁面积（{0}）/天// target_dialog_qtxmbmj: 请填写目标面积// target_dialog_qtxmbsc: 请填写目标时长

export default {
  mixins: [dialogMixins],
  data() {
    return {
      form: {
        goalArea: '',
        goalTime: '',
        locationId: 0,
        siteId: 0,
        startTime: '',
        endTime: '',
      },
    };
  },
  computed: {
    cleanAreaDay() {
      return this.$t('target_dialog_qjmjt', [ this.$formatLenUnit() ]);
    },
    rules() {
      return {
        goalArea: [{ required: true, message: this.$t('target_dialog_qtxmbmj') }],
        goalTime: [{ required: true, message: this.$t('target_dialog_qtxmbsc') }],
      };
    },
  },
  mounted() {
    this.mergeLanguage(null, 'portal_target_dialog');
    this.initDialog();
  },
  methods: {
    // 初始化
    initDialog: function () {
      this.$setFormatData(this.form, this.model.row, 'locationId,siteId,startTime,endTime');
      // this.form.goalArea = this.$formatLenLocal(this.model.row.goalArea);
    },
    // 确认保存
    confirm: function () {
      this.$refs.form.validate((valid) => {
        if (!valid) {
          return;
        }
        this.form.goalArea = this.$formatLenUpload(this.form.goalArea);
        this.$postJSON(apis.LocationSetGoal, this.form).then(() => {
          this.$message({
            message: this.$t('com_handle_success'),
            type: 'success',
          });
          this.visible = false;
          this.$emit('success', this.form);
        });
      });
    },
  },
};
</script>

<style lang="scss"></style>
